export default "__VITE_ASSET__3f89c838__"